import React, { useEffect, useRef } from 'react';

const faqs = [
  { q: 'How much do you charge?', a: "Pricing is tailored to your setup and goals. Once we understand your business, we provide a custom quote. What we can say upfront: we're almost always more affordable than building an in-house SDR team, and deliver stronger return on investment." },
  { q: 'How do you qualify leads?', a: "Every lead runs through a proven multi-step warm-up process. Before a meeting hits your calendar, that lead has been contacted multiple times across email and phone to confirm interest, budget, and fit, so you're only ever speaking to prospects who match your criteria." },
  { q: 'How long until I see results?', a: "You'll begin seeing traction shortly after the 2\u20133 week setup and warm-up phase. In most cases, clients start seeing qualified leads within the first 3 days of launch, and many generate a positive ROI by the end of the first month." },
  { q: 'Which industries do you work with?', a: "We work primarily with B2B agencies, SaaS, professional services, and consulting firms with an average deal size above $3K. If that's you, we're a fit. If you sell to consumers or price below $500 per deal, we're probably not." },
  { q: 'Do I need to have a sales team already?', a: 'No. Many of our clients are founder-led with no dedicated sales staff. We fill the top of the funnel, qualified meetings on your calendar, and you close them. We can also recommend closers from our partner network.' },
  { q: "What's the contract length?", a: 'We operate on rolling monthly agreements. We believe in earning your business every month, not locking you in.' },
];

export default function Faq() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const onClick = (e) => {
      const btn = e.target.closest('.faq-question');
      if (!btn || !root.contains(btn)) return;
      const item = btn.closest('.faq-item');
      if (!item) return;
      const wasOpen = item.dataset.open === 'true';
      // Close all
      root.querySelectorAll('.faq-item').forEach((i) => {
        i.dataset.open = 'false';
      });
      // Open this one if it was closed
      if (!wasOpen) item.dataset.open = 'true';
    };

    root.addEventListener('click', onClick);
    // Set initial open state on first item
    const first = root.querySelector('.faq-item');
    if (first) first.dataset.open = 'true';
    return () => root.removeEventListener('click', onClick);
  }, []);

  return (
    <section id="faq">
      <div className="container-x">
        <div className="faq-grid">
          <div className="reveal">
            <span className="eyebrow">Frequently Asked</span>
            <h2 className="section-heading" style={{ marginTop: 24 }}>
              Everything you'd want to ask, <span className="text-gradient">before the call</span>.
            </h2>
            <p style={{ marginTop: 20, color: 'var(--text-muted)', fontSize: 16, lineHeight: 1.55 }}>
              Can't find what you're looking for? Drop us a note and we'll get back to you the same day.
            </p>
          </div>
          <div className="faq-list" ref={rootRef}>
            {faqs.map((f, i) => (
              <div key={i} className="faq-item reveal" data-open="false" style={{ transitionDelay: `${i * 0.04}s` }}>
                <button type="button" className="faq-question" aria-label={f.q}>
                  <span className="faq-q-text">{f.q}</span>
                  <span className="faq-chevron" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </button>
                <div className="faq-answer">
                  <div className="faq-answer-inner">{f.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
